import { useState, useEffect } from "react";
import parse from "html-react-parser";
import "./hero.scss";
import Button from "../Button";
import Div from "../Div";
import { imgUrl } from "../../helper";

export default function Hero({
  title,
  subtitle,
  btnText,
  btnLink,
  scrollDownId,
  bgImages = []
}) {

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if(bgImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % bgImages.length);
    }, 5000); // change every 5s

    return () => clearInterval(interval);
  }, [bgImages]);

  return (
    <Div className="cs-hero cs-style1 cs-shape_wrap_1">

      {/* Background images */}
      <div className="hero-bg-wrapper">
        {bgImages.map((img, index) => (
          <div
            key={index}
            className={`hero-bg ${index === current ? "active" : ""}`}
            style={{ backgroundImage: `url(${imgUrl(img)})` }}
          />
        ))}
      </div>

      <Div className="container">
        <Div className="cs-hero_text">
          <h1 className="cs-hero_title">{parse(title)}</h1>

          <Div className="cs-hero_info">
            <Div>
              <Div className="cs-hero_subtitle">{subtitle}</Div>
            </Div>

            <Div>
              <Button btnLink={btnLink} btnText={btnText} />
            </Div>
          </Div>
        </Div>
      </Div>

      <a href={scrollDownId} className="cs-down_btn">.</a>

    </Div>
  );
}